import React, { useState } from 'react'
import clsx from 'clsx'
import { Step, StepLabel, Stepper } from '@material-ui/core'
import { rootStyle, useColorlibStepIconStyles, QontoConnector } from "./style.js"
import Icon from '../../../utils/icons.js'

function ProvisionStepper(props) {
  const {activeStep, progressSteps, incomplete = false} = props
  const [getProgress] = useState({...progressSteps})
  const classes = rootStyle()

  const STATES = [
    { label: 'CONFIRM_SITE', status: false },
    { label: 'QR_SCAN', status: false },
    { label: 'SITE_SETUP', status: false },
    { label: 'INSTALL', status: false },
  ]
  
  function ColorlibStepIcon(props) {
      const classes = useColorlibStepIconStyles()
      const { active, completed } = props
      const WrenchSVG = ({ color }) => (
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.7354 2.24585C12.7692 2.05748 13.8365 2.18864 14.7939 2.62183C14.9733 2.703 15.1013 2.86761 15.1367 3.06128C15.172 3.25504 15.11 3.45423 14.9707 3.59351L12.1035 6.4607L12.0693 6.51245C12.0614 6.53174 12.0576 6.55274 12.0576 6.57398C12.0576 6.61514 12.0734 6.65439 12.1016 6.68433L13.3154 7.8982C13.3455 7.92701 13.3851 7.94403 13.4268 7.94409C13.4691 7.94409 13.5098 7.92685 13.54 7.89722L16.4072 5.03003L16.4629 4.9812C16.5968 4.87668 16.77 4.83316 16.9395 4.86402C17.1332 4.89932 17.2977 5.02739 17.3789 5.20679C17.8122 6.16427 17.9432 7.23146 17.7549 8.26538C17.5665 9.29931 17.0674 10.2517 16.3242 10.9949C15.5811 11.738 14.6287 12.2362 13.5947 12.4246C12.6994 12.5877 11.78 12.5105 10.9277 12.2058L5.94434 17.1902C5.52887 17.6056 4.96545 17.8395 4.37793 17.8396C3.79025 17.8396 3.2261 17.6057 2.81055 17.1902C2.39506 16.7746 2.16211 16.2104 2.16211 15.6228C2.16225 15.0354 2.39518 14.4718 2.81055 14.0564L7.79395 9.07202C7.48964 8.22015 7.41314 7.3008 7.57617 6.40601C7.7646 5.37208 8.26369 4.41966 9.00684 3.67652C9.74991 2.9336 10.7016 2.43425 11.7354 2.24585ZM13.4287 3.43726C12.9438 3.34189 12.4426 3.33702 11.9512 3.42652C11.1572 3.57118 10.4252 3.95447 9.85449 4.52515C9.28398 5.09572 8.90156 5.82707 8.75684 6.62085C8.61219 7.41473 8.71232 8.23428 9.04492 8.96948C9.14787 9.19699 9.0994 9.46477 8.92285 9.64136L3.65918 14.905C3.46885 15.0954 3.36147 15.3536 3.36133 15.6228C3.36133 15.8922 3.46874 16.1511 3.65918 16.3416C3.84969 16.5321 4.10851 16.6394 4.37793 16.6394C4.64719 16.6393 4.90528 16.5319 5.0957 16.3416L10.3594 11.0779C10.536 10.9013 10.8038 10.8529 11.0312 10.9558C11.7665 11.2885 12.5859 11.3895 13.3799 11.2449C14.1738 11.1002 14.9049 10.7168 15.4756 10.1462C16.0462 9.57565 16.4295 8.84438 16.5742 8.05054C16.6639 7.55852 16.6581 7.05647 16.5625 6.57105L14.3848 8.74976L14.3799 8.75464C14.1254 9.00396 13.7831 9.14331 13.4268 9.14331C13.0704 9.14325 12.7281 9.00405 12.4736 8.75464L12.4697 8.74976L11.251 7.53101L11.2461 7.5271C10.9968 7.2726 10.8574 6.93026 10.8574 6.57398C10.8574 6.21771 10.9968 5.87535 11.2461 5.62085L11.251 5.61597L11.2588 5.60913L13.4287 3.43726Z" fill={color}/>
</svg>

      );
      const wrenchColor = (active || completed) ? '#01B5DE' : '#BABEC3';
      let icons = {
          1: <Icon src="siteOn" />,
          2: active || completed ? <Icon src="scanOn" /> : <Icon src="scanOff" />,
          3: active || completed ? <Icon src="setupOn" /> : <Icon src="setupOff" />,
          4: <WrenchSVG color={wrenchColor} />,
      };

      return (
          <>
              
              <div
                  className={clsx(classes.root, {
                      [classes.active]: active,
                      [classes.completed]: completed,
                      [classes.incomplete]: active && incomplete
                  })}
              >
                  {icons[String(props.icon)]}

              </div>

          </>
      );
  }

  return (
    <Stepper alternativeLabel activeStep={activeStep} className={classes.stepperBackgroundColor}>
      {STATES.map((item, index)  => (
        <Step key={index} connector={<QontoConnector />}>
            {index > 0 &&
                <div  className={classes.stepLabelLine} style={{width: `${getProgress["step"+index]}%`}}></div>}
          <StepLabel
            StepIconComponent={ColorlibStepIcon}
            props={true}
          ></StepLabel>
        </Step>
      ))}
    </Stepper>
  )
}

export default ProvisionStepper
